import { action, makeObservable, observable } from 'mobx';

const SIDEBAR_COLLAPSED_KEY = 'provider_sidebar_collapsed';

const readSidebarCollapsed = (): boolean => {
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch {
        return false;
    }
};

export class LayoutStore {
    constructor() {
        makeObservable(this, {
            sidebarCollapsed: observable,
            toggleSidebar: action,
            collapseSidebar: action,
        });
    }

    public sidebarCollapsed = readSidebarCollapsed();

    /** The user's choice — remembered across reloads. */
    public readonly toggleSidebar = (status = !this.sidebarCollapsed) => {
        this.sidebarCollapsed = status;
        try {
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(status));
        } catch {
            // storage unavailable — the choice just won't survive a reload
        }
    };

    /**
     * Automatic close (the core Sidebar collapses itself on narrow screens on every navigation).
     * Not persisted: a phone-width visit must not overwrite the user's desktop preference.
     */
    public readonly collapseSidebar = () => {
        this.sidebarCollapsed = true;
    };
}
